module.exports = __webpack_public_path__ + "static/logo-6e20c202062e3040d25d0a752f87bd57.png";